import CustomBrowserRouter from '@onepercentio/one-ui/context/CustomBrowserRouter'
import ROUTES, { TO_GALLERY } from 'core/modules/router'
import { matchPath, useHistory } from 'react-router-dom'
import { History } from 'history'
import { PropsWithChildren, useEffect } from 'react'

/**
 * Locks the route from changing.
 * Usefull when the user hasn't got to the final state
 * and the async processes are progressing
 */
export function useLockRouteChange(
  hasPendingProcess: boolean,
  whatToSayToUser: string
) {
  const h = useHistory()
  useEffect(() => {
    if (hasPendingProcess)
      return h.block(() => {
        return window.confirm(whatToSayToUser) ? undefined : false
      })
  }, [hasPendingProcess])
}

export default function CustomRouter({ children }: PropsWithChildren<{}>) {
  const changeRouteToGalleryBound = (r: string, history: History<unknown>) => {
    const { galleryId } =
      matchPath<{ galleryId: string }>(history.location.pathname, {
        path: ROUTES.unauthenticated.galleryDetail,
      })?.params || {}

    if (!galleryId) return r

    const galleryBoundRoute = [
      ROUTES.unauthenticated.marketplace,
      ROUTES.authenticated.sellMarketplace,
      ROUTES.authenticated.marketplaceOfferBuy,
      ROUTES.unauthenticated.marketplaceAssetDetail,
      ROUTES.authenticated.offerItemDetail,
      ROUTES.authenticated.collectionItemDetail,
      ROUTES.authenticated.pendingPayment,
      ROUTES.unauthenticated.assetDetail,
    ].find(
      (route) =>
        matchPath<{ galleryId: string }>(r?.split('?').at(0)!, {
          path: route,
        })?.isExact
    )

    if (galleryBoundRoute) return TO_GALLERY(galleryId)(r)
    return r
  }
  return (
    <CustomBrowserRouter
      beforeRouteChange={(r, history) => {
        if (typeof r !== "string") return r
        const newRoute = changeRouteToGalleryBound(r, history)
        return newRoute
      }}>
      {children}
    </CustomBrowserRouter>
  )
}
